var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"all"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"imgsize"},[_c('img',{attrs:{"src":_vm.nowImg,"alt":""}})]),_c('div',{staticClass:"title"},[_vm._v("页面不见了，请稍后试试")])])]),_c('bottom-bar',{staticClass:"bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }